module.exports = __webpack_public_path__ + "static/media/celebration_icon.1cb629aa.svg";